import { ViewBasic } from '@quatrecentquatre/manage-me';
import { bindAll } from 'underscore';

export class ParkHeader extends ViewBasic{
    constructor(options) {
        super(options);
        //set default variables
    }

    initialize() {
        bindAll(this, ['scrollHandler', 'showHideMenu', 'updateActiveMenuItem']);
        this.lastScrollTop = 0;

        // Élements pour le surlignement dynamique du menu FAQ
        this.faqSection = document.querySelector('#park-faq');
        this.faqMenuLink = this.el.querySelector('a[href*="#park-faq"]');
        this.infosMenuLink = this.el.querySelector('a[href$="/infos"]');

        this.addEvents();
    }

    addEvents() {
        document.addEventListener('scroll', this.scrollHandler);
        document.addEventListener('scroll', this.updateActiveMenuItem);
    }

    removeEvents() {
        document.removeEventListener('scroll', this.scrollHandler);
        document.removeEventListener('scroll', this.updateActiveMenuItem);
    }

    /**
     * Snap header when scrolling
     * @param e: scroll event
     */
    scrollHandler(e) {
        const element = this.el.querySelector('.park-primary-navigation');
        const trigger = this.el.previousElementSibling;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                element.classList.remove("fixed");
                this.el.style.height = '';
                document.querySelector('.primary-navigation').classList.remove('force-hide')
            } else {
                let scrollTop = document.documentElement.scrollTop;
                if(scrollTop > this.el.offsetTop) {
                    element.classList.add("fixed");
                    this.el.style.height = element.offsetHeight + 'px';
                    document.querySelector('.primary-navigation').classList.add('force-hide');
                }
            }
        });

        observer.observe(trigger);
    }

    /**
     * Bascule le surlignement entre "Infos utiles" et "FAQ" selon
     * la position de scroll par rapport à la section FAQ
     */
    updateActiveMenuItem() {
        // Seulement sur la page infos où la section FAQ existe
        if (!this.faqSection || !this.faqMenuLink || !this.infosMenuLink) {
            return;
        }

        const navHeight = this.el.querySelector('.park-primary-navigation').offsetHeight;
        const detectionOffset = 200; // Distance avant la section FAQ pour activer le surlignement
        const faqTop = this.faqSection.getBoundingClientRect().top;

        if (faqTop <= navHeight + detectionOffset) {
            // La section FAQ a atteint le haut: surligner FAQ
            this.faqMenuLink.classList.add('active');
            this.infosMenuLink.classList.remove('active');
        } else {
            // Au-dessus de la section FAQ: surligner Infos utiles
            this.faqMenuLink.classList.remove('active');
            this.infosMenuLink.classList.add('active');
        }
    }

    showHideMenu(scroll) {
        if (scroll === 'down') {
            this.el.querySelector('.park-primary-navigation').classList.add('hide-up');
        } else if (scroll === 'up') {
            if(this.el.querySelector('.park-primary-navigation').classList.contains('hide-up')) {
                this.el.querySelector('.park-primary-navigation').classList.remove('hide-up');
            }
        }
    }
}

Me.views['ParkHeader'] = ParkHeader;
